import React, { useContext } from "react";
import { useWindowDimensions } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { InlineRichText } from "../../components/RichText";
import { FurnitureContext } from "../../utils/furniture";
import { QuizContext } from "../../utils/quiz";
import { Body, Container, Cta, Hero, Main, Title } from "./styles";

const QuizIntro = ({ navigation }) => {
    const { width } = useWindowDimensions();
    const windowWidth = Math.floor(width);
    const { getQuiz, start, headerHeight } = useContext(QuizContext);
    const {
        strings: { startCta },
    } = useContext(FurnitureContext);
    const quiz = getQuiz();
    const { title, titleRich } = quiz;
    const theTitle = titleRich ? <InlineRichText doc={titleRich} /> : title;
    const photoUrl = `https:${quiz.photo.url}?w=${windowWidth}&fm=jpg`;
    return (
        <SafeAreaProvider>
            <Container style={{ paddingTop: headerHeight }}>
                <Hero source={{ uri: photoUrl }} />
                <Main>
                    <Title type="h5">{theTitle}</Title>
                    <Body type="body2">{quiz.introduction}</Body>
                </Main>
                <Cta title={startCta} onPress={() => start()} />
            </Container>
        </SafeAreaProvider>
    );
};

export default QuizIntro;
